export const CIBIO_CONSULTA_FILTER_KEYS = {
	AAC: 'cibio_consulta_filtros_aac',
	AMI: 'cibio_consulta_filtros_ami',
	AI: 'cibio_consulta_filtros_ai',
	AE: 'cibio_consulta_filtros_ae',
} as const;

const LEGACY_KEYS = ['aac_consulta_filtros'];

type LoadOptions = {
	isRequester: boolean;
	uniqueName: string;
	solicitanteField?: string;
	dateFields?: string[];
};

type SaveOptions = {
	isRequester?: boolean;
	solicitanteField?: string;
};

export const clearAllCibioConsultaFilters = () => {
	Object.values(CIBIO_CONSULTA_FILTER_KEYS).forEach((key) => {
		sessionStorage.removeItem(key);
	});
	LEGACY_KEYS.forEach((key) => sessionStorage.removeItem(key));
};

// F5/fechamento da aba zera os filtros; navegação SPA (visualizar/voltar) mantém.
if (typeof window !== 'undefined') {
	window.addEventListener('beforeunload', () => {
		clearAllCibioConsultaFilters();
	});
}

export const saveCibioConsultaFilters = (
	key: string,
	filters: any,
	options: SaveOptions = {}
) => {
	const solicitanteField = options.solicitanteField || 'solicitante';
	const solicitante = filters?.[solicitanteField] || '';

	sessionStorage.setItem(
		key,
		JSON.stringify({
			...filters,
			[solicitanteField]: solicitante,
			solicitanteLimpo: options.isRequester
				? !solicitante
				: !!filters?.solicitanteLimpo,
		})
	);
};

export const loadCibioConsultaFilters = (
	key: string,
	getDefaults: () => any,
	options: LoadOptions
) => {
	try {
		const raw = sessionStorage.getItem(key);
		if (!raw) return null;

		const parsed = JSON.parse(raw);
		const solicitanteField = options.solicitanteField || 'solicitante';
		const solicitanteLimpo = !!parsed.solicitanteLimpo;
		const solicitanteSalvo = parsed[solicitanteField];

		const solicitante = options.isRequester
			? solicitanteLimpo
				? solicitanteSalvo || ''
				: solicitanteSalvo || options.uniqueName
			: solicitanteSalvo || '';

		const dates: Record<string, Date | null> = {};
		(options.dateFields || []).forEach((field) => {
			dates[field] = parsed[field] ? new Date(parsed[field]) : null;
		});

		return {
			...getDefaults(),
			...parsed,
			[solicitanteField]: solicitante,
			solicitanteLimpo,
			...dates,
		};
	} catch {
		return null;
	}
};
